document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('solutionsHubSearch');
    const clearButton = document.getElementById('solutionsHubSearchClear');
    const resetButton = document.getElementById('solutionsHubReset');
    const resultCount = document.getElementById('solutionsHubResultCount');
    const emptyState = document.getElementById('solutionsHubEmpty');
    const cards = Array.from(document.querySelectorAll('[data-solutions-hub-card]'));
    const filters = Array.from(document.querySelectorAll('[data-solutions-filter]'));

    if (!searchInput || cards.length === 0) {
        return;
    }

    let activeFilter = 'all';

    function normalize(value) {
        return value
            .toLocaleLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    function applyFilters() {
        const query = normalize(searchInput.value.trim());
        let visibleCount = 0;

        cards.forEach(function (card) {
            const matchesFilter = activeFilter === 'all' || card.dataset.scenario === activeFilter;
            const matchesQuery = !query || normalize(card.textContent).includes(query);
            const isVisible = matchesFilter && matchesQuery;

            const details = card.querySelector('[data-solutions-hub-details]');
            if (details && query) {
                details.open = isVisible;
            }

            card.classList.toggle('d-none', !isVisible);
            if (isVisible) {
                visibleCount++;
            }
        });

        filters.forEach(function (filter) {
            const isActive = filter.dataset.solutionsFilter === activeFilter;
            filter.setAttribute('aria-pressed', String(isActive));
            filter.classList.toggle('btn-primary', isActive);
            filter.classList.toggle('text-white', isActive);
            filter.classList.toggle('btn-light', !isActive);
            filter.classList.toggle('text-body', !isActive);
        });

        if (resultCount) {
            resultCount.textContent = resultCount.dataset.resultsTemplate.replace('{0}', visibleCount);
        }

        if (emptyState) {
            emptyState.classList.toggle('d-none', visibleCount > 0);
        }

        if (clearButton) {
            clearButton.classList.toggle('d-none', searchInput.value.length === 0);
        }
    }

    filters.forEach(function (filter) {
        filter.addEventListener('click', function () {
            activeFilter = filter.dataset.solutionsFilter;
            applyFilters();
        });
    });

    searchInput.addEventListener('input', applyFilters);

    if (clearButton) {
        clearButton.addEventListener('click', function () {
            searchInput.value = '';
            applyFilters();
            searchInput.focus();
        });
    }

    if (resetButton) {
        resetButton.addEventListener('click', function () {
            activeFilter = 'all';
            searchInput.value = '';
            applyFilters();
            searchInput.focus();
        });
    }
});
